import { render } from "./IndividualSM.vue?vue&type=template&id=6b0ce2ed&scoped=true"
import script from "./IndividualSM.vue?vue&type=script&lang=js"
export * from "./IndividualSM.vue?vue&type=script&lang=js"

import "./IndividualSM.vue?vue&type=style&index=0&id=6b0ce2ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0ce2ed"]])

export default __exports__